var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "AddForm",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.formSubmitted($event)
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Project Name*",
                              "label-for": "project-name",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Project Name",
                                vid: "Project Name",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "project-name",
                                            placeholder: "Project Name",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.project.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.project, "name", $$v)
                                            },
                                            expression: "project.name",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Description*",
                              "label-for": "description",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Description",
                                vid: "Description",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-textarea", {
                                          attrs: {
                                            id: "description",
                                            placeholder: "Description",
                                            rows: "3",
                                            required: "",
                                          },
                                          model: {
                                            value: _vm.project.description,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression: "project.description",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Customer",
                              "label-for": "customer",
                            },
                          },
                          [
                            _vm.loadingCustomer
                              ? _c("b-spinner", {
                                  staticClass: "mx-2",
                                  attrs: { variant: "primary" },
                                })
                              : _c("b-form-select", {
                                  attrs: {
                                    name: "customer",
                                    options: _vm.optionsCustomer,
                                  },
                                  model: {
                                    value: _vm.project.customerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.project, "customerId", $$v)
                                    },
                                    expression: "project.customerId",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Assignee*",
                              "label-for": "assignee",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Assignee",
                                vid: "Assignee",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("v-select", {
                                          attrs: {
                                            id: "assignee",
                                            taggable: "",
                                            "push-tags": "",
                                            dir: "ltr",
                                            multiple: "",
                                            label: "text",
                                            options: _vm.assignee,
                                          },
                                          model: {
                                            value: _vm.project.assigneeId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project,
                                                "assigneeId",
                                                $$v
                                              )
                                            },
                                            expression: "project.assigneeId",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Approver*",
                              "label-for": "approver",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Approver",
                                vid: "Approver",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            id: "approver",
                                            name: "approver",
                                            options: _vm.assignee,
                                          },
                                          model: {
                                            value: _vm.project.approverId,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.project,
                                                "approverId",
                                                $$v
                                              )
                                            },
                                            expression: "project.approverId",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Supervisor",
                              "label-for": "supervisor",
                            },
                          },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "supervisor",
                                taggable: "",
                                "push-tags": "",
                                dir: "ltr",
                                multiple: "",
                                label: "text",
                                options: _vm.assignee,
                              },
                              model: {
                                value: _vm.project.supervisorId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.project, "supervisorId", $$v)
                                },
                                expression: "project.supervisorId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Budget", "label-for": "budget" } },
                          [
                            _c("b-form-input", {
                              attrs: { id: "budget", min: "0", type: "number" },
                              model: {
                                value: _vm.project.budget,
                                callback: function ($$v) {
                                  _vm.$set(_vm.project, "budget", $$v)
                                },
                                expression: "project.budget",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Duration",
                              "label-for": "estimates",
                            },
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                id: "estimates",
                                min: "0",
                                type: "number",
                              },
                              model: {
                                value: _vm.project.estimates,
                                callback: function ($$v) {
                                  _vm.$set(_vm.project, "estimates", $$v)
                                },
                                expression: "project.estimates",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      {
                        staticClass: "d-flex justify-content-between",
                        attrs: { md: "12" },
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { type: "button", variant: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.formSubmitted()
                              },
                            },
                          },
                          [_vm._v("Submit")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }